module.exports = __webpack_public_path__ + "img/table-addrb-icon.33515533.svg";